import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import WidgetsLoader from '@components/WidgetsLoader';
import PageNotFound from '@pages/PageNotFound';
import ForgotPassword from '@pages/ForgotPassword';
import ResetPassword from '@pages/ResetPassword';

const LoginPage = lazy(() => import('@pages/Login'));

const AuthLayout = () => {
  return (
    <Suspense fallback={<WidgetsLoader />}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/password-reset/:uid/:token/"
          element={<ResetPassword />}
        />
        <Route path="/404" element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AuthLayout;
